import { useAppAuth } from '@/providers/AppAuthProvider';

// The cookie (BFF) session's user and logout (GSB-7612), provided by AuthInitProvider.
const useAuth = () => useAppAuth();

export default useAuth;
